export const disabledDays = ({ date }, responseAvailableDates, currentDate) => {
  if (
    responseAvailableDates &&
    responseAvailableDates.res &&
    responseAvailableDates.availableDates
  ) {
    const availableDates = responseAvailableDates.availableDates;
    const formattedAvailableDates = Object.values(availableDates).flatMap(
      (dates) =>
        Object.values(dates).map((dateObj) => {
          const availableDate = dateObj.date;
          const [day, month, year] = availableDate.split("/");
          return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        })
    );

    const isCurrentDate = date.getTime() >= currentDate.getTime();

    return (
      !formattedAvailableDates.some(
        (formattedDate) => formattedDate.getTime() === date.getTime()
      ) ||
      (!isCurrentDate && !isToday(date))
    );
  }

  return true;
};

export const isToday = (date) => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const onClickDay = (
  day,
  responseAvailableDates,
  setSelectedAppointment,
  setSelectedDate,
  setAppointmentSelected
) => {
  const selectedDate = new Date(day);
  setSelectedDate(selectedDate);

  // Resetear selección de cita al cambiar día
  setAppointmentSelected(null);

  const formattedSelectedDate = formatDate(day);
  const availableDates = responseAvailableDates.availableDates;

  for (const prop in availableDates) {
    if (availableDates.hasOwnProperty(prop) && prop === formattedSelectedDate) {
      const selectedDateData = availableDates[prop];
      setSelectedAppointment(selectedDateData);
      return;
    }
  }
  setSelectedAppointment(null);
};

export const formatDate = (date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};
